module.exports = __webpack_public_path__ + "img/logo1.dd3855c3.png";